import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../icon/';
import Text from '../../../type/text';

import './style.scss';

const Pill = ({ text, onDismiss }) => {
  return (
    <span className="uni-pill">
      <Text level="micro" color="contrast" className="uni-pad--quarter--horiz">
        {text}
      </Text>
      <span className="uni-pill__dismiss" onClick={onDismiss}>
        <Icon size="small" type="uidismiss" />
      </span>
    </span>
  );
};

Pill.propTypes = {
  text: PropTypes.string.isRequired,
  onDismiss: PropTypes.func,
};

Pill.defaultProps = {
  onDismiss: () => {},
};

export default Pill;



// WEBPACK FOOTER //
// ./src/selects/__partials/pill/index.jsx